<template>
  <v-row>
    <v-col cols="12">
      <Filtro />
    </v-col>
    <v-col cols="12">
      <Table />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Sincronizacoes",

  components: {
    Filtro: () => import("./components/Filtro"),
    Table: () => import("./components/Table")
  }
};
</script>
